<div class="container-fluid px-1 px-md-3">
	<h1 class="my-3">Configuracion de Ticket</h1>

	<app-loading [is_loading]="is_loading"></app-loading>

	<div class="card p-3 my-3">
		<h4>Informacion General</h4>
		<div class="row">
			<div class="col-12 col-md-6">
				<label class="form-label">Nombre</label>
				<input type="text" class="form-control" [(ngModel)]="ticket.name" placeholder="Ej: Ticket POS Principal">
			</div>
			<div class="col-12 col-md-6">
				<label class="form-label">Estilo de Calculo</label>
				<select class="form-control" [(ngModel)]="ticket.calculation_style">
					<option value="NORMAL">Normal (Practico)</option>
					<option value="SAT_FACTURA">SAT Factura</option>
				</select>
				<small class="text-muted">Normal: calculos practicos. SAT: desglose de IVA/IEPS para facturacion.</small>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-6">
				<label class="form-label">Columnas Font A</label>
				<input type="number" class="form-control" [(ngModel)]="ticket.font_a_columns" min="20" max="80" placeholder="32">
				<small class="text-muted">Numero de columnas para font A (letra grande). Default: 32</small>
			</div>
			<div class="col-12 col-md-6">
				<label class="form-label">Columnas Font B</label>
				<input type="number" class="form-control" [(ngModel)]="ticket.font_b_columns" min="20" max="80" placeholder="42">
				<small class="text-muted">Numero de columnas para font B (letra pequena). Default: 42</small>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Helper de Imagen para Ticket</h4>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Ancho de imagen (px)</label>
				<input type="number" class="form-control" [(ngModel)]="ticket.image_width" min="8" max="384" step="8" placeholder="128">
				<small class="text-muted">Debe ser multiplo de 8. Default: 128px.</small>
			</div>
			<div class="col-12 col-md-8">
				<label class="form-label">Seleccionar imagen (se redimensiona, blanco y negro)</label>
				<input type="file" class="form-control" accept="image/*" (change)="onImageSelected($event)" #imageInput>
			</div>
		</div>
		<canvas #resizeCanvas style="display: none;"></canvas>
	</div>

	<div class="card p-3 my-3">
		<h4>Encabezado y Pie</h4>
		<div class="row">
			<div class="col-12 col-md-6">
				<label class="form-label">Encabezado (Header)</label>
				<textarea class="form-control" [(ngModel)]="ticket.header" rows="3" placeholder="Texto que aparece al inicio del ticket"></textarea>
			</div>
			<div class="col-12 col-md-6">
				<label class="form-label">Pie (Footer)</label>
				<textarea class="form-control" [(ngModel)]="ticket.footer" rows="3" placeholder="Texto que aparece al final del ticket"></textarea>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12">
				<label class="form-label">Texto venta a credito</label>
				<textarea class="form-control" [(ngModel)]="ticket.credit_sale_text" rows="3" placeholder="Si no esta vacio se imprime antes del codigo de facturacion"></textarea>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Configuracion de Articulos</h4>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Nombre del articulo</label>
				<select class="form-control" [(ngModel)]="ticket.item_name_display">
					<option *ngFor="let opt of name_display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Cantidad (Columna 1)</label>
				<select class="form-control" [(ngModel)]="ticket.item_qty1_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Cantidad (Columna 2)</label>
				<select class="form-control" [(ngModel)]="ticket.item_qty2_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Precio unitario</label>
				<select class="form-control" [(ngModel)]="ticket.item_price_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Cantidad x Precio</label>
				<select class="form-control" [(ngModel)]="ticket.item_qty_times_price_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Subtotal</label>
				<select class="form-control" [(ngModel)]="ticket.item_subtotal_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Total del articulo</label>
				<select class="form-control" [(ngModel)]="ticket.item_total_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Signo de moneda ($)</label>
				<select class="form-control" [(ngModel)]="ticket.item_money_sign_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Nota del articulo</label>
				<select class="form-control" [(ngModel)]="ticket.item_note_display">
					<option value="NEVER">Nunca</option>
					<option value="ALWAYS">Siempre</option>
				</select>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Configuracion de Opciones/Excepciones</h4>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Mostrar fila de opciones</label>
				<select class="form-control" [(ngModel)]="ticket.option_row_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Mostrar articulo de opcion</label>
				<select class="form-control" [(ngModel)]="ticket.option_item_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Precio de opcion</label>
				<select class="form-control" [(ngModel)]="ticket.option_price_display">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Cantidad por articulo</label>
				<select class="form-control" [(ngModel)]="ticket.option_qty_by_item">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Total de cantidad</label>
				<select class="form-control" [(ngModel)]="ticket.option_total_qty">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Total cantidad x precio</label>
				<select class="form-control" [(ngModel)]="ticket.option_total_qty_times_price">
					<option *ngFor="let opt of display_options" [value]="opt.value">{{opt.label}}</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-4 mb-3">
				<label class="form-label">Excepciones</label>
				<select class="form-control" [(ngModel)]="ticket.exceptions_display">
					<option value="NEVER">Nunca</option>
					<option value="ONLY_IF_PRESENT">Solo si hay excepciones</option>
				</select>
			</div>
		</div>
	</div>

	<div class="card p-3 my-3">
		<h4>Configuracion de Orden</h4>
		<div class="row">
			<div class="col-12 col-md-4">
				<label class="form-label">Nota de la orden</label>
				<select class="form-control" [(ngModel)]="ticket.order_note_display">
					<option value="NEVER">Nunca</option>
					<option value="ALWAYS">Siempre</option>
				</select>
			</div>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12">
			<div class="d-grid gap-2 d-md-flex justify-content-md-end">
				<button type="button" class="btn btn-secondary" (click)="location.back()">Cancelar</button>
				<button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="is_loading">
					<span *ngIf="is_loading">Guardando...</span>
					<span *ngIf="!is_loading">Guardar Configuracion</span>
				</button>
			</div>
		</div>
	</div>
</div>
